export const receiptManager = [
  {
    path: '/receiptManager/createBefore',
    name: 'receiptCreateBefore',
    component: () => import('views/receiptManager/createBefore/index'),
    meta: {
      title: '新建收款单',
      keepAlive: false
    }
  },
  {
    path: '/receiptManager/create',
    name: 'receiptCreate',
    component: () => import('views/receiptManager/create/index'),
    meta: {
      title: '新建收款单'
    }
  },
  {
    path: '/receiptManager/edit',
    name: 'receiptEdit',
    component: () => import('views/receiptManager/receiptEdit/index'),
    meta: {
      title: '收款项编辑'
    }
  },
  {
    path: '/receiptManager/aiCreate',
    name: 'aiReceiptCreate',
    component: () => import('views/receiptManager/aiCreate/index'),
    meta: {
      title: '收款单小助手',
      keepAlive: true
    }
  },
  {
    path: '/receiptManager/update',
    name: 'receiptUpdate',
    component: () => import('views/receiptManager/receiptUpdate/index'),
    meta: {
      title: '修改收款单'
    }
  },
  {
    path: '/receiptManager/receiptDetail',
    name: 'newReceiptDetail',
    component: () => import('views/receiptManager/receiptDetail/index'),
    meta: {
      title: '收款单详情',
      keepAlive: true
    }
  },
  {
    path: '/receiptManager/receiptDetail/search',
    name: 'newReceiptDetailSearch',
    component: () => import('views/receiptManager/receiptDetail/search/index'),
    meta: {
      title: '筛选'
    }
  },
  {
    path: '/receiptManager/receiptQrcode',
    name: 'receiptQrcode',
    component: () => import('views/receiptManager/receiptQrcode/index'),
    meta: {
      title: '收款码'
    }
  }
]
